<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改车辆所有人信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="vehicleOwnerInfo" :rules="rules" style="display: inline;">
      <FormItem prop="name">
        <label style="display: inline-block; width: 60px;">车辆所有人名称</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleOwnerInfo.name" placeholder="请输入车辆所有人名称">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <label style="display: inline-block; width: 60px;">联系电话</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleOwnerInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <label style="display: inline-block; width: 60px;">联系地址</label>
        <Input style="display: inline-block; width: 200px;" :disabled="!modify" v-model="vehicleOwnerInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 400px;" :disabled="!modify" type="textarea"
               v-model="vehicleOwnerInfo.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'VehicleOwnerInfoDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆所有人名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      modify: false,
      vehicleOwnerInfo: {
        id: null,
        name: null,
        phoneNum: null,
        address: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleOwnerInfoServ_GetDetail',
      'VehicleOwnerInfoServ_ModifyObj'
    ]),
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改车辆所有人信息',
          content: '<p>确认修改车辆所有人信息</p>',
          onOk: () => {
            store.dispatch('VehicleOwnerInfoServ_ModifyObj', {
              params: this.vehicleOwnerInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let vehicleOwnerInfoId = this._initValue
            store.dispatch('VehicleOwnerInfoServ_GetDetail', {
              params: { id: vehicleOwnerInfoId }
            }).then(() => {
              this.vehicleOwnerInfo = store.getters.get_VehicleOwnerInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.id = null
        this.vehicleOwnerInfo.name = null
        this.vehicleOwnerInfo.phoneNum = null
        this.vehicleOwnerInfo.address = null
        this.vehicleOwnerInfo.remark = null
        let vehicleOwnerInfoId = this._initValue
        if (vehicleOwnerInfoId) {
          store.dispatch('VehicleOwnerInfoServ_GetDetail', {
            params: { id: vehicleOwnerInfoId }
          }).then(() => {
            this.vehicleOwnerInfo = store.getters.get_VehicleOwnerInfo_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
